import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  isAuto: false,
  regframe: false,
  lipidlayertime: 10,
  isDrawNIBUT: 1,
  isDrawBUT: 1,
  FBUTtime: 3,
  isDrawBlink: 1,
  BlinkTime: 60,
  SelectLight: true,
  TearheightSelectLight: true,
  // 0:人眼 1:模拟眼
  EyeMaterial: 0,
  testMaxValue: 100,
  testInterval: 500
};
class Caputre extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("capture.json"), DEFAULTSET);
  }
  getCaptureSettings() {
    return this.getSettings();
  }
  saveCaptureSettings(settings) {
    this.saveSettings(settings);
  }
}
export default Caputre;



// WEBPACK FOOTER //
// ./src/settings/capture.js